/* eslint-disable jira/filename-case */
export const NAVIGATION_ITEM = 'navigationItem';
export const BUTTON = 'button';
export const DROPDOWN_ITEM = 'dropdownItem';
export const SEARCH_INPUT = 'searchInput';

export type ActionSubjectType =
	| typeof BUTTON
	| typeof NAVIGATION_ITEM
	| typeof DROPDOWN_ITEM
	| typeof SEARCH_INPUT;
